import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  isV2Store(storeId: string | null | undefined): boolean {
    if (!storeId) return false;
    return environment.flagV2Stores.includes(storeId);
  }
}
